export const COMPANYTYPE = {
    "CO": "CO",
    "EM": "EM",
    "SO": "SO"
}

export const REGISTERTYPE = {
    "PERSON": "PERSON",
    "COMPANY": "COMPANY"
}

export const DRIVERSEAT = {
    "E": "E",
    "D": "D"
}

export const HKVEHICLEREGISTERTYPE = {
    "LIGHT_TRUCK": "LIGHT_TRUCK",
    "MEDIUM_TRUCK": "MEDIUM_TRUCK",
    "HEAVY_TRUCK": "HEAVY_TRUCK",
    "TRACTOR": "TRACTOR",
    "TOW_TRUCK": "TOW_TRUCK",
}